// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DashboardUI_layout__q5C8H {
  height: 100vh;
  overflow: hidden;
  background-color: #f2f2f2;
}

.DashboardUI_sider__oowtu {
  background-color: var(--darkGray);
  overflow: auto;
  height: 100vh;
  position: sticky;
  inset-inline-start: 0;
  top: 0;
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #777 var(--darkGray);
}

.DashboardUI_sider__oowtu::-webkit-scrollbar {
  width: 8px;
}

.DashboardUI_sider__oowtu::-webkit-scrollbar-track {
  background: var(--darkGray);
}

.DashboardUI_sider__oowtu::-webkit-scrollbar-thumb {
  background-color: #555;
  border-radius: 4px;
  border: 2px solid var(--darkGray);
}

.DashboardUI_sider__oowtu::-webkit-scrollbar-thumb:hover {
  background-color: #777;
}

.DashboardUI_logoWrap__CcW6N {
  margin-bottom: 25px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.DashboardUI_logo__W299n {
  color: white;
  width: 87px;
}

.DashboardUI_nav__ePoDu {
  background-color: var(--darkGray);
  border-right: none;
}

.DashboardUI_item__ysN4Q {
  color: #dedede;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  font-size: 16px;
  border-bottom: 1px solid #878787;
  font-family: BebasNeue;
  font-weight: 700;
}

.DashboardUI_item__ysN4Q:first-child {
  border-top: 1px solid #878787;
}

.DashboardUI_active__YBHNF {
  background-color: var(--orange);
  color: white;
}

.DashboardUI_active__YBHNF:hover {
  color: white !important;
}

.DashboardUI_item__ysN4Q span {
  display: block;
  margin-top: 10px;
}

.DashboardUI_item__ysN4Q:hover {
  color: #dedede;
}

.DashboardUI_header__IcO79 {
  background-color: transparent;
  height: 81px;
  padding-inline: 1rem;
}

.DashboardUI_account__TskWs {
  line-height: 18px;
  font-size: 16px;
  font-family: BebasNeue;
  font-weight: 700;
}

.DashboardUI_logoMobile__sGGAn {
  width: 91px;
  color: var(--orange);
  display: none;
}

.DashboardUI_headerInfo__SjS4S {
  flex: 1 1;
  display: flex;
  padding: 27px 0;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  color: #3c3c3c;
}

.DashboardUI_title__l8n4F {
  font-family: BebasNeue;
  font-size: 24px;
  line-height: 24px;
  font-weight: 700;
}

.DashboardUI_wrapDate__XJJiR {
  display: flex;
  align-items: center;
}

.DashboardUI_date__ALyhD {
  display: block;
  margin-left: 5px;
  font-weight: 300;
  font-family: BebasNeue;
  font-size: 18px;
  line-height: 18px;
  text-transform: uppercase;
  font-weight: 700;
}

.DashboardUI_accountWrap__O2qLJ {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.DashboardUI_chevron__DkuZb {
  margin: 0 10px;
}

.DashboardUI_menuToggle__SLPz8 {
  display: none;
}

.DashboardUI_iconAccount__nUIHM {
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.DashboardUI_content__VlFyV {
  padding: 30px 50px;
  height: calc(100vh - 81px - 60px);
  overflow-y: auto;
}

.DashboardUI_powered__ewYzC {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: BebasNeue;
  height: 60px;
}

.DashboardUI_powered__ewYzC a {
  display: flex;
  align-items: center;
  justify-content: center;
}

.DashboardUI_powered__ewYzC span {
  margin-right: 10px;
  display: block;
}

.DashboardUI_powered__ewYzC img {
  width: 150px;
}

@media only screen and (max-width: 992px) {
  .DashboardUI_header__IcO79 {
    background-color: white;
    display: flex;
  }

  .DashboardUI_headerInfo__SjS4S {
    border-bottom: none;
  }

  .DashboardUI_menuToggle__SLPz8 {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    color: var(--darkGray);
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    height: 38px;
    width: 38px;
    box-shadow: none;
  }

  .DashboardUI_title__l8n4F,
  .DashboardUI_wrapDate__XJJiR,
  .DashboardUI_account__TskWs,
  .DashboardUI_chevron__DkuZb {
    display: none;
  }

  .DashboardUI_logoMobile__sGGAn {
    display: flex;
  }

  .DashboardUI_iconAccount__nUIHM {
    height: 30px;
    padding-left: 15px;
    border-left: 1px solid #d2d2d2;
  }

  .DashboardUI_content__VlFyV {
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/styles/DashboardUI.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,MAAM;EACN,wBAAwB;EAExB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gCAAgC;EAChC,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;IACf,eAAe;IACf,UAAU;IACV,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;IAIE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".layout {\n  height: 100vh;\n  overflow: hidden;\n  background-color: #f2f2f2;\n}\n\n.sider {\n  background-color: var(--darkGray);\n  overflow: auto;\n  height: 100vh;\n  position: sticky;\n  inset-inline-start: 0;\n  top: 0;\n  scrollbar-gutter: stable;\n\n  scrollbar-width: thin;\n  scrollbar-color: #777 var(--darkGray);\n}\n\n.sider::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sider::-webkit-scrollbar-track {\n  background: var(--darkGray);\n}\n\n.sider::-webkit-scrollbar-thumb {\n  background-color: #555;\n  border-radius: 4px;\n  border: 2px solid var(--darkGray);\n}\n\n.sider::-webkit-scrollbar-thumb:hover {\n  background-color: #777;\n}\n\n.logoWrap {\n  margin-bottom: 25px;\n  margin-top: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.logo {\n  color: white;\n  width: 87px;\n}\n\n.nav {\n  background-color: var(--darkGray);\n  border-right: none;\n}\n\n.item {\n  color: #dedede;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px 0;\n  font-size: 16px;\n  border-bottom: 1px solid #878787;\n  font-family: BebasNeue;\n  font-weight: 700;\n}\n\n.item:first-child {\n  border-top: 1px solid #878787;\n}\n\n.active {\n  background-color: var(--orange);\n  color: white;\n}\n\n.active:hover {\n  color: white !important;\n}\n\n.item span {\n  display: block;\n  margin-top: 10px;\n}\n\n.item:hover {\n  color: #dedede;\n}\n\n.header {\n  background-color: transparent;\n  height: 81px;\n  padding-inline: 1rem;\n}\n\n.account {\n  line-height: 18px;\n  font-size: 16px;\n  font-family: BebasNeue;\n  font-weight: 700;\n}\n\n.logoMobile {\n  width: 91px;\n  color: var(--orange);\n  display: none;\n}\n\n.headerInfo {\n  flex: 1;\n  display: flex;\n  padding: 27px 0;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #c1c1c1;\n  color: #3c3c3c;\n}\n\n.title {\n  font-family: BebasNeue;\n  font-size: 24px;\n  line-height: 24px;\n  font-weight: 700;\n}\n\n.wrapDate {\n  display: flex;\n  align-items: center;\n}\n\n.date {\n  display: block;\n  margin-left: 5px;\n  font-weight: 300;\n  font-family: BebasNeue;\n  font-size: 18px;\n  line-height: 18px;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.accountWrap {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n\n.chevron {\n  margin: 0 10px;\n}\n\n.menuToggle {\n  display: none;\n}\n\n.iconAccount {\n  height: 26px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.content {\n  padding: 30px 50px;\n  height: calc(100vh - 81px - 60px);\n  overflow-y: auto;\n}\n\n.powered {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: BebasNeue;\n  height: 60px;\n}\n\n.powered a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.powered span {\n  margin-right: 10px;\n  display: block;\n}\n\n.powered img {\n  width: 150px;\n}\n\n@media only screen and (max-width: 992px) {\n  .header {\n    background-color: white;\n    display: flex;\n  }\n\n  .headerInfo {\n    border-bottom: none;    \n  }\n\n  .menuToggle {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    background: transparent;\n    color: var(--darkGray);\n    font-size: 24px;\n    cursor: pointer;    \n    padding: 0;\n    height: 38px;\n    width: 38px;\n    box-shadow: none;\n  }\n\n  .title,\n  .wrapDate,\n  .account,\n  .chevron {\n    display: none;\n  }\n\n  .logoMobile {\n    display: flex;\n  }\n\n  .iconAccount {\n    height: 30px;\n    padding-left: 15px;\n    border-left: 1px solid #d2d2d2;\n  }\n\n  .content {\n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `DashboardUI_layout__q5C8H`,
	"sider": `DashboardUI_sider__oowtu`,
	"logoWrap": `DashboardUI_logoWrap__CcW6N`,
	"logo": `DashboardUI_logo__W299n`,
	"nav": `DashboardUI_nav__ePoDu`,
	"item": `DashboardUI_item__ysN4Q`,
	"active": `DashboardUI_active__YBHNF`,
	"header": `DashboardUI_header__IcO79`,
	"account": `DashboardUI_account__TskWs`,
	"logoMobile": `DashboardUI_logoMobile__sGGAn`,
	"headerInfo": `DashboardUI_headerInfo__SjS4S`,
	"title": `DashboardUI_title__l8n4F`,
	"wrapDate": `DashboardUI_wrapDate__XJJiR`,
	"date": `DashboardUI_date__ALyhD`,
	"accountWrap": `DashboardUI_accountWrap__O2qLJ`,
	"chevron": `DashboardUI_chevron__DkuZb`,
	"menuToggle": `DashboardUI_menuToggle__SLPz8`,
	"iconAccount": `DashboardUI_iconAccount__nUIHM`,
	"content": `DashboardUI_content__VlFyV`,
	"powered": `DashboardUI_powered__ewYzC`
};
export default ___CSS_LOADER_EXPORT___;
